import { Card, CardContent } from "@b2b/ui-components";
import { cn } from "../../lib/utils";
import { LucideIcon } from "lucide-react";

interface StatsCardProps {
  title: string;
  value: string;
  change?: string;
  changeType?: "positive" | "negative" | "neutral";
  icon: LucideIcon;
  variant?: "default" | "primary";
}

export function StatsCard({
  title,
  value,
  change,
  changeType = "neutral",
  icon: Icon,
  variant = "default"
}: StatsCardProps) {
  // Tailwind equivalents for status colors
  const changeColor = {
    positive: "text-green-600",     // was text-success
    negative: "text-red-600",       // was text-destructive
    neutral: "text-gray-500"        // was text-muted-foreground
  };

  return (
    <Card
      className={cn(
        "shadow-md hover:shadow-lg transition duration-300",
        variant === "primary" &&
          "bg-gradient-to-r from-orange-500 to-orange-600 text-white border border-orange-600"
      )}
    >
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div className="space-y-2">
            {/* Title */}
            <p
              className={cn(
                "text-sm font-medium",
                variant === "primary" ? "text-white/80" : "text-gray-500"
              )}
            >
              {title}
            </p>

            {/* Value */}
            <p
              className={cn(
                "text-2xl font-bold",
                variant === "primary" ? "text-white" : "text-gray-900"
              )}
            >
              {value}
            </p>

            {/* Change */}
            {change && (
              <p
                className={cn(
                  "text-sm font-medium",
                  variant === "primary" ? "text-white/90" : changeColor[changeType]
                )}
              >
                {change}
              </p>
            )}
          </div>

          {/* Icon */}
          <div
            className={cn(
              "w-12 h-12 rounded-lg flex items-center justify-center",
              variant === "primary"
                ? "bg-white/20 text-white"
                : "bg-orange-100 text-orange-600"
            )}
          >
            <Icon className="w-6 h-6" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
